import { useEffect } from "react";

const SIDENAMN = "Kommuneopprøret";

const setMeta = (nokkel, verdi, property = false) => {
  if (!verdi) return;
  const attr = property ? "property" : "name";
  let tag = document.head.querySelector(`meta[${attr}="${nokkel}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, nokkel);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", verdi);
};

const setCanonical = () => {
  let link = document.head.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", window.location.origin + window.location.pathname);
};

/** Set sidetittel, meta-beskriving og Open Graph-taggar for søk og deling. */
export const useSideTittel = (tittel, beskriving) => {
  useEffect(() => {
    const full = tittel ? `${tittel} | ${SIDENAMN}` : SIDENAMN;
    document.title = full;
    setMeta("description", beskriving);
    setMeta("og:title", full, true);
    setMeta("og:description", beskriving, true);
    setMeta("og:type", "website", true);
    setMeta("og:site_name", SIDENAMN, true);
    setMeta("og:url", window.location.href, true);
    setMeta("twitter:card", "summary", false);
    setMeta("twitter:title", full, false);
    setMeta("twitter:description", beskriving, false);
    setCanonical();
  }, [tittel, beskriving]);
};

export default useSideTittel;
